<template>
  <div class="bindPage rightPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @addFn="addFn"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @dataImFn="dataImFn"
        @netFn="netFn"
      />
      <div class="componentPage">
        <UnkonwTable
          :tableData="tableData"
          v-bind="$attrs"
          :loading="loading"
          @choozeTable="choozeTable"
          @editRowFn="editRowFn"
          @delRowFn="delRowFn"
          @detailFn="detailFn"
          @ATConfigFn="ATConfigFn"
        />
        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
    <!-- 详情 -->
    <!-- <DetailDialog :isDetailShow.sync="isDetailShow" :title="title" :detailObj="detailObj"
    :deviceProperty="deviceProperty" :deviceType="deviceType" :netObj="netObj" v-bind="$attrs" ref="detailDialog"
    @changdetail="changdetail" /> -->
    <!-- 修改范围 -->
    <EditScope
      :isShowEditShow.sync="isShowEditShow"
      :scopeArray="scopeArray"
      ref="scopedId"
    />
    <!-- 新增&&编辑 -->
    <AddEdit
      v-if="isShow"
      v-bind="$attrs"
      :isShow.sync="isShow"
      :title="title"
      :scopeArray="scopeArray"
      :editRow="editRow"
      ref="vForm"
    />
    <!-- 上传 -->
    <importDialog :isShowImDialog.sync="isShowImDialog" ref="importDia" />
    <!-- 网络参数 -->
    <Net
      :isShow.sync="isNetShow"
      :title="title"
      :choozeTableData="choozeTableData"
      ref="net"
    />
  </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'

import UnkonwTable from './UnkonwTable.vue'

import AddEdit from '../components/AddEditDialog.vue'
import EditScope from '../components/EditScope.vue'
import importDialog from '../components/gatewayIm.vue'
import Net from '../components/VNet.vue'

import { shareScope } from '@/api/modules/public.js'
import {
  gatewayDel,
  gatewayList,
  getGatewayDetailInfo
} from '@/api/modules/gateway.js'
import { getIsPlatform } from '@/utils/permission'

export default {
  mixins: [getAllTreePath],
  components: {
    UnkonwTable,
    AddEdit,
    EditScope,
    importDialog,
    Net
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newVal) {
        console.log(newVal)
        this.formContent[1].selectParam = newVal
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if (
        (!currentUser.sysScope && currentUser.scopeAdmin) ||
        currentUser.type === 2
      ) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'device.gateway_name',
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 2,
          text: 'device.gateway_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 3,
          text: 'device.mac_address',
          type: 'input',
          paramsName: 'mac',
          isChooze: false
        }
      ],
      SearchForm: {
        scopeName: null,
        name: null,
        type: null,
        mac: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 3,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //   id: 4,
        //   icon: '',
        //   vHas: ['incubatorAddCarrier'],
        //   text: 'public.net_param',
        //   method: 'netFn'
        // },
        // {
        //   id: 5,
        //   icon: '',
        //   vHas: ["incubatorAddCarrier"],
        //   text: $t('integration.form_template'),
        //   method: 'tableTelFn'
        // },
        {
          id: 6,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.import_data',
          method: 'dataImFn'
        }
      ],
      choozeTableData: [],
      title: '',
      // 修改范围
      isShowEditShow: false,
      // 详情
      isDetailShow: false,
      // 传感器的基础信息
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      netObj: {},
      // 新增&&编辑
      isShow: false,
      scopeArray: [],
      editRow: {},
      // 上传
      isShowImDialog: false,
      // 网络参数
      isNetShow: false
      // rowData: {},
      // isShowConfig: false,
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
      this.optareBtn.push({
        id: 2,
        icon: '',
        vHas: ['incubatorAddCarrier'],
        text: 'device.modify_customer',
        method: 'editScopeFn'
      })
    }
    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    /** 分页 */
    getListFn () {
      this.loading = true
      gatewayList(this.SearchForm, 'unknown')
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        scopeName: null,
        name: null,
        type: null,
        mac: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 获取范围 */
    getSence () {
      if (this.scopeArray.length > 0) return
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 新增 */
    addFn () {
      this.editRow = null

      this.isShow = true
      this.title = $t('integration.new_gateway')
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        this.$refs.vForm.dioForm.id = null
      })
    },
    /** 修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) {
        return this.$message.error(
          $t('integration.the_selected_sensor_is_not_the_same_customer')
        )
      }
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId =
          this.choozeTableData[0].scene_id + ''

        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 单条编辑 */
    editRowFn (row) {
      this.title = this.$t('integration.edit_gateway', { mac: row.mac })
      this.getSence()
      getGatewayDetailInfo(row.id).then(({ result }) => {
        // 先合并 gateway 对象（包含 mac、name、type 等核心字段）
        // 再合并 netConfig 和 alarmConfig，确保 gateway 的核心字段不被覆盖
        this.editRow = {
          ...result.netConfig,
          ...result.alarmConfig,
          ...result.gateway
        }
        console.log('editRow -> ', this.editRow)
        console.log('gateway -> ', result.gateway)
        console.log('gateway.mac -> ', result.gateway.mac)
        this.isShow = true
        this.$nextTick(() => {
          this.$refs.vForm.clearValidate()
        })
      })
    },
    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = {
            ids: idList.join(','),
            edited: 2
          }

          gatewayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = {
            ids: row.id,
            edited: 2
          }

          gatewayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('gatewayParam', row.id, row.name)
      // this.isDetailShow = true;
      // this.title = `[${row.mac}]${this.$t('public.details')}`;
      // getGatewayDetailInfo(row.id).then(({ result }) => {
      //   let url = `${result.gateway.scopeName||result.gateway.scopeName}`;
      //   result.gateway.url = url;
      //   result.deviceType.pictureBase64 = result.gateway.pictureBase64 || result.deviceType.pictureBase64;
      //   result.deviceType.id = result.gateway.id
      //   result.deviceType.description = result.gateway.description
      //   // 基础信息
      //   this.detailObj = Object.assign(result.gateway, result.deviceProperty||{},result.deviceType||{});
      //   // 属性信息
      //   this.deviceType = result.deviceType;
      //   this.deviceProperty = result.deviceProperty || {};
      //   // 网关参数
      //   this.netObj = result.netConfig || {}
      // })
    },
    /** at指令 拿取之前的代码 */
    ATConfigFn (row) {
      const { name, mac, carrierName } = row
      const routeurl = this.$router.resolve({
        path: '/atinstruction',
        query: {
          name,
          mac,
          carrierName
        }
      })
      const iWidth = 1280
      const iHeight = 700
      const iTop = (window.screen.height - 30 - iHeight) / 2 // 获得窗口的垂直位置;
      const iLeft = (window.screen.width - 10 - iWidth) / 2 // 获得窗口的水平位置;
      window.open(
        routeurl.href,
        'AT',
        `height=${iHeight},innerHeight=${iHeight},width=${iWidth},innerWidth=${iWidth},top=${iTop},left=${iLeft},toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no`
      )
    },
    /** 表格模板 */
    // tableTelFn() {
    //   getGeneraUploadTemplateFile('gateway', this.$i18n.locale).then((res) => {
    //     if (res) {
    //       this.$message.success($t('integration.download_successful'))
    //     }
    //   })
    // },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isNetShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    // 数据导入
    dataImFn () {
      this.isShowImDialog = true
      this.$nextTick(() => {
        if (this.$refs.importDia.$refs.refFile) {
          this.$refs.importDia.$refs.refFile.clearFiles()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  height: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
